export const SET_LOADING = 'src/store/customer/SET_LOADING'
export const SET_CUSTOMERS = 'src/store/customer/SET_CUSTOMERS'
export const SET_CUSTOMERS_RESPONSE = 'src/store/customer/SET_CUSTOMERS_RESPONSE'
